import React from 'react'

export const PermissionContext = React.createContext({
  userPermissions: [],
  isAllowed: () => {},
})

export const PermissionProvider = PermissionContext.Provider
export const PermissionConsumer = PermissionContext.Consumer
